import { useEffect, useRef, useState } from "react";
import { isDevHost } from "@/lib/site";

export const HINT_FREQ = 341;
export const HINT_SPAN = 3;  // amber flicker while passing 338–344

// Only when arriving from the 010230 Easter egg link (?h=1 + referrer 010230.com). The flag is removed from the URL.
export function useDialHint() {
  const [hint] = useState(() => {
    if (new URLSearchParams(window.location.search).get("h") !== "1") return false;
    let ref = "";
    try { ref = new URL(document.referrer).hostname.replace(/^www\./, ""); } catch { /* no referrer */ }
    return ref === "010230.com" || isDevHost();
  });
  useEffect(() => {
    const u = new URL(window.location.href);
    if (u.searchParams.has("h")) { u.searchParams.delete("h"); window.history.replaceState(null, "", u); }
  }, []);
  return hint;
}

// 2–3 brief needle twitches toward 341 within the first 20 s. Never moves the dial itself.
export function useTwitch(on, freq) {
  const [kick, setKick] = useState(0);
  const f = useRef(freq);
  f.current = freq;
  useEffect(() => {
    if (!on) return undefined;
    const timers = [];
    const n = 2 + Math.floor(Math.random() * 2);
    const times = Array.from({ length: n }, (_, i) => 2500 + i * (16000 / n) + Math.random() * (16000 / n - 1500));
    times.forEach((t) => {
      timers.push(setTimeout(() => {
        // The needle rests at the far left, so a twitch is a brief upward kick (a ping from 341).
        if (f.current === HINT_FREQ) return;
        const dir = 1;
        setKick(dir * (22 + Math.random() * 12));
        timers.push(setTimeout(() => setKick(dir * 8), 140));
        timers.push(setTimeout(() => setKick(0), 300));
      }, t));
    });
    return () => timers.forEach(clearTimeout);
  }, [on]);
  return kick;
}
